import { DatabaseZap, Gift } from "lucide-react";
import React from "react";
import ProgressBar from "./ProgressBar";

export default function GiftCodeCard({
  title,
  value,
  progressPercentage,
  icon,
  smallIcon,
  color,
}) {
  //const safe=color.text || "text-blue-600";
  const Icon = icon;
  const SmallIcon = smallIcon;
  return (
    <div
      className="bg-white/80 dark:bg-slate-900/80
       backdrop-blur-xl rounded-2xl  
       border border-state-200/50 dark:border-slate-700/50 
       hover:shadow-xl hover:shadow-slate-900/20 
       p-4
       transition-all duration-300 group "
    >
      <div className="w-full flex flex-col">
        <div className="w-full flex items-start justify-between">
          <div className="flex flex-col ">
            {/* title */}
            <div className="flex items-center justify-start space-x-2">
              <SmallIcon className="w-4 h-4 text-black dark:text-slate-200" />
              <h2 className="text-sm font-medium text-black dark:text-slate-200">
                {title}
              </h2>
            </div>
            {/* value */}
            <h1 className="text-3xl font-bold text-black dark:text-slate-200 mt-4">
              {value}
            </h1>
            {progressPercentage == null && (
              <p className="text-xs  text-slate-700/80 dark:text-slate-400 mt-1">
                All Inventory Items
              </p>
            )}
          </div>
         
          {/* icon */}
          <Icon
            className={`w-10 h-10 p-2 rounded-lg  ${color.text} ${color.icon_bg} `}
          />
        </div>
        
        {/* progress bar */}
        {progressPercentage!=null && (
          <div className="mt-4">
            <ProgressBar
              progressPercentage={progressPercentage}
              color={color.progress_bg}
              h={2}
            />
          </div>
        )}
      </div>
    </div>
  );
}
